type KnownImportMeta = {
  env?: Partial<{
    DEV: boolean;
    PROD: boolean;
  }>;
};

const getMetaEnv = (): KnownImportMeta['env'] | undefined => {
  if (typeof import.meta === 'undefined') {
    return undefined;
  }

  return (import.meta as KnownImportMeta).env;
};

export const isDevelopmentMode = (): boolean => {
  const metaEnv = getMetaEnv();
  if (typeof metaEnv?.DEV !== 'undefined') {
    return Boolean(metaEnv.DEV);
  }

  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV !== 'production';
  }

  return false;
};

export const isProductionMode = (): boolean => {
  const metaEnv = getMetaEnv();
  if (typeof metaEnv?.PROD !== 'undefined') {
    return Boolean(metaEnv.PROD);
  }

  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV === 'production';
  }

  return false;
};